import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { logo, logo111, signature } from "../../../assets/img";

const RelievingLetter = () => {
    const ref = useRef();

    const [d, setD] = useState({
        ref: "HRO Chennai/2022/R001162",
        date: "",
        name: "",
        designation: "",
        manager: "",
        doj: "",
        empId: "",
        department: "",
    });

    const handleChange = (e) => {
        setD({ ...d, [e.target.name]: e.target.value });
    };

    const downloadPDF = async () => {
        const pdf = new jsPDF("p", "mm", "a4");
        const pages = ref.current.querySelectorAll(".page_11");

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], { scale: 2 });
            const img = canvas.toDataURL("image/png");

            const w = 210;
            const h = (canvas.height * w) / canvas.width;

            if (i > 0) pdf.addPage();
            pdf.addImage(img, "PNG", 0, 0, w, h);
        }

        pdf.save(`${d.name || "RelievingLetter"}.pdf`);
    };

    return (
        <div className="rl-container">

            {/* FORM */}
            <div className="rl-form">
                <input name="name" placeholder="Employee Name" onChange={handleChange} />
                <input name="designation" placeholder="Designation" onChange={handleChange} />
                <input name="manager" placeholder="Manager Name" onChange={handleChange} />
                <input name="doj" type="date" onChange={handleChange} />
                <input name="date" type="date" onChange={handleChange} />
                <input name="empId" placeholder="Employee ID" onChange={handleChange} />
                <input name="department" placeholder="Department" onChange={handleChange} />
            </div>

            {/* DOCUMENT */}
            <div ref={ref}>
                <div className="rl-page">

                    
                    <img src={logo111} className="rl-watermark" />

                  
                    <div className="header_11">
                        <img src={logo} className="logo1111" />
                    </div>

                   
                    <div className="rl-content">

                        <p className="rl-date f3 fs-14"><b>Date :{d.date}</b></p>

                        <h2 className="rl-title f3 fs-22"><b>Relieving & Service Certificate</b></h2>

                        <p className="rl-name">Mr. {d.name}</p>

                        <p className="rl-text">Emp Code: {d.empId}</p>

                        <p className="rl-text"><b>Dear {d.name}</b></p>

                        <p className="rl-text fs-16">
                            This is to certify that you have been relived from the services of the company effective from {d.date}
                        </p>

                        <h4 className="rl-subtitle fs-16">
                           <b> Your Service Record with the company is as follows:</b>
                        </h4>

                        <p className="rl-text">Date of Joining: {d.doj}</p>

                        <p className="rl-text">Date of Leaving: {d.date}</p>

                        <p className="rl-text">Designation: {d.designation}</p>

                        <p className="rl-text">
                            We thank you for your efforts and contribution during your tenure with us and wish you all the best in your future endeavors.
                        </p>

                        <div className="rl-signature">
                            <img src={signature} className="rl-sign-img" />
                            <p className="rl-sign-text">Authorized Signature</p>
                        </div>

                    </div>

                    {/* FOOTER */}
                    <div className="rl-footer">
                                                <div className="company-header">
                         <h4 className="f3 fs-14">redcloud Soft Solution Private Limited</h4>
                            <p className="f1 fs-14">173,6th Floor, Block B, TECCI Park, OMR, Shollinganallur, Chennai - 600119</p>
                            <p className="f1 fs-14">+91-90439 02239 | WWW.redcloudsolutions.in | hr@redcloudsolutions.in</p>
                            <p className="f1 fs-14">CIN U72900TN2022PTC154867</p>
                            </div>
                    </div>

                </div>
            </div>

            <button onClick={downloadPDF} className="rl-btn">
                Download PDF
            </button>
        </div>
    );
};

export default RelievingLetter;